export default __webpack_public_path__ + "static/tip1-853238eb1766021db5cc56046796fc9d.png";